import React, {useContext,useEffect,Fragment,useState } from 'react';
import PropTypes from 'prop-types';
import {useTheme} from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import Modal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import '../../scss/components/_data_sharing.scss';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import MaterialTable from 'material-table';
import TableIcons from '../TableIcons';
import Cookies from 'js-cookie';
import API_PATH from "../../constants/config.json";
import MapContext from '../../context/MapContext';
import { withStyles } from '@material-ui/core/styles';
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;
function TabPanel(props) {
    const { children, value, index, ...other } = props;  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  const IOSSwitch = withStyles((theme) => ({
    root: {
      width: 44,
      height: 24,
      padding: 0,
      margin: 0,
    },
    switchBase: {
      padding: 2,
      '&$checked': {
        transform: 'translateX(20px)',
        color: theme.palette.common.white,
        '& + $track': {
          backgroundColor: '#52d869',
          opacity: 1,
          border: 'none',
        },
      },
      '&$focusVisible $thumb': {
        color: '#52d869',
        border: '6px solid #fff',
      },
    },
    thumb: {
      width: 20,
      height: 20,
    },
    track: {
      borderRadius: 24,
      border: `0px solid ${theme.palette.grey[400]}`,
      backgroundColor: '#E4E4E7',
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
  }))(({ classes, ...props }) => {
    return (
      <Switch
        focusVisibleClassName={classes.focusVisible}
        disableRipple
        classes={{
          root: classes.root,
          switchBase: classes.switchBase,
          thumb: classes.thumb,
          track: classes.track,
          checked: classes.checked,
        }}
        {...props}
      />
    );
});
  
  //Start Intersection component code ...
  const DataSharing = props => {
    const theme = useTheme();
    const {enabledAgency}=useContext(MapContext)
    const [tabValue, setTabValue] = React.useState(0);
    const [sharingMyStation, setSharingMyStation] = React.useState(false);    
    const [openConfirmationShared, setOpenConfirmationShared] = React.useState(false);   
    const handleOpenConfirmationShared = () => setOpenConfirmationShared(true);
    const handleCloseConfirmationShared = () => setOpenConfirmationShared(false);
    useEffect(() => { 
      setSharingMyStation(props.is_shared);   
    }, [props.is_shared])
    const handleChangeTab = (event, newValue) => {      
      setTabValue(newValue);
    };    
    const handleCancelConfirmationShared = () => {
      setSharingMyStation(false); 
      setOpenConfirmationShared(false);      
    }
    const changeSharedOption = (e) =>{
      let is_sharing = e.target.checked;   
      setSharingMyStation(is_sharing);          
      if(is_sharing){
        setOpenConfirmationShared(true)  
      }else{
        unshareMyAgency();  
      }     
    }
    const enabledSharedMyAgency = () =>{
      if(sharingMyStation){
        shareMyAgency();
      }
    }
    const shareMyAgency = () =>{
      try {
        axios({
          method: 'post',
          headers: {
            'payload': Cookies.get('payload'),
            'agencyid': sessionStorage.getItem('agency_id')
          },
          url: API_URL + API_PATH.sharedAgency,
        })
          .then(function (response) {
            if (response.status && response.status == '200') {  
              setSharingMyStation(true);             
              handleCloseConfirmationShared(); 
            }
          }).catch(function (error) {
            console.log(error)
          })
      } catch (error) {
        console.error(error);
      } 
    }
    const unshareMyAgency = () =>{
      try {
        axios({
          method: 'delete',
          headers: {
            'payload': Cookies.get('payload'),
            'agencyid': sessionStorage.getItem('agency_id')
          },
          url: API_URL + API_PATH.unsharedAgency,
        })
          .then(function (response) {
            if (response.status && response.status == '200') {
              handleCloseConfirmationShared();
            }
          }).catch(function (error) {
            console.log(error)
          })
      } catch (error) {
        console.error(error);
      } 
    }
    const enabledAgencyOnMap = (e,agency,agency_id) =>{
      let visible = e.target.checked;            
      try {
        axios({
          method: 'post',
          data : {
            option_agency_id : agency_id,
            enabled : visible
          },
          headers: {
            'payload': Cookies.get('payload'),
            'agencyid': sessionStorage.getItem('agency_id')
          },
          url: API_URL + API_PATH.disabledStationsByAgency,
        })
          .then(function (response) {
            if (response.status && response.status == '200') {
              enabledAgency({visible : visible,name : agency})
              props.updateAgencies();
            }
          }).catch(function (error) {
            console.log(error)
          })
      } catch (error) {
        console.error(error);
      }      
    }
    //
    return (
        <React.Fragment><Modal
            open={props.openSharedDataMd}
            onClose={props.handleCloseSharedDataMd}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"                          
        >
            <div className='md-data-sharing' style={!tabValue?{maxWidth:'520px'}:{maxWidth:'664px'}}>
                <div className='md-data-sharing-header'>
                    <Tabs value={tabValue} onChange={handleChangeTab} className='tb-hd-main-opts' aria-label="basic tabs example">
                        <Tab label="Share my stations" {...a11yProps(0)} style={{width:'144px'}} />
                        <Tab label="Shared stations" {...a11yProps(1)} style={{width:'129px'}}/>              
                    </Tabs>
                    <IconButton aria-label="delete" style={{position: 'absolute',top: 0,right: 0,padding: '15px'}} onClick={props.handleCloseSharedDataMd}>
                      <img src={require("../../assets/icons/close.svg")} /> 
                    </IconButton>
                </div>                
                <div className='md-data-sharing-body'>
                  <SwipeableViews
                          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                          index={tabValue}
                          onChangeIndex={handleChangeTab}
                  >
                    <TabPanel value={tabValue} index={0} dir={theme.direction}>
                      <div className='md-data-sharing-body-shared'>
                        <label>Share my stations</label>
                        <p>Enabling station sharing allows other participating users to view and access your station data, and download count data.</p>
                        <FormGroup>
                          {/*<FormControlLabel control={<Switch defaultChecked={props.is_shared} onChange={changeSharedOption} />} label="Share my stations" /> */}
                          <FormControlLabel control={<IOSSwitch checked={sharingMyStation} onChange={changeSharedOption} />} label="Share my stations"/>                         
                        </FormGroup>
                        {/*<div className='shared-options'>
                          <Button className='shared-options-cancel' variant="contained" onClick={props.handleCloseSharedDataMd}>Cancel</Button>
                          <Button className='shared-options-save' variant="contained" onClick={handleOpenConfirmationShared}>Save</Button>
                        </div>*/}
                      </div>                        
                    </TabPanel>
                    <TabPanel value={tabValue} index={1} dir={theme.direction}>
                        <div className='md-data-sharing-agencies'>                          
                          <MaterialTable   
                              icons={TableIcons} 
                              title="All agencies"
                              className='tb-shared-info'                                           
                                  options={{
                                    search:true,
                                    paging:false,
                                    toolbar:true,
                                    sorting:false,
                                    draggable: false,
                                    paging: true,
                                    pageSize: 10
                                  }}                    
                                  columns={[
                                      { title: 'Agency name', field: 'display_name',width: '288px', cellStyle:{fontSize: '14px'}},
                                      { title: 'Status', field: 'sharing',width: '104px', cellStyle:{fontSize: '14px'},
                                      render: rowData => {                            
                                        return <>{rowData.sharing?<span className='rw-agencie-shared'>Shared</span>:<span className='rw-agencie-unshared'>Unshared</span>}</>;
                                      }},
                                      { title: '# of stations', field: 'stations',width: '112px', cellStyle:{fontSize: '14px'}},
                                      { title: 'Toggle visability', field: 'enabled',width: '128px', cellStyle:{fontSize: '14px'},
                                      render: rowData => {                            
                                        return <><FormControlLabel control={<IOSSwitch disabled={!rowData.sharing} defaultChecked={(rowData.sharing && rowData.enabled)?true:false} onChange={(e)=>enabledAgencyOnMap(e,rowData.display_name,rowData.agency_id)} />} label="" /></>;                                        
                                      }},
                                                                            
                                  ]}
                                  data={props.agencies}                                  
                          />
                        </div>                        
                    </TabPanel>
                  </SwipeableViews>  
                </div>
            </div>
        </Modal>
        <Modal
            open={openConfirmationShared}
            onClose={handleCloseConfirmationShared}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"                          
        >
          <div className='confirmation-shared'>
            <div className='confirmation-shared-icon'>
              <img src={require('../../assets/icons/shared_data_icon.svg')} />
            </div>
            <div className='confirmation-shared-mnsg'>
              <label>Share my stations</label>
              <span>Are you sure you want to share your data? Other organizations will be able view your stations, and download count data.</span>
            </div>
            <div className='shared-options'>
              <Button className='shared-options-cancel-enabled' variant="contained" onClick={handleCancelConfirmationShared}>Cancel</Button>
              <Button className='shared-options-enabled' variant="contained" onClick={enabledSharedMyAgency}>Confirm</Button>
            </div>
          </div>
        </Modal>
        </React.Fragment>
    )
  }
  export default DataSharing;